import { render } from "./ValidationTable.vue?vue&type=template&id=7108b9a4&scoped=true&ts=true"
import script from "./ValidationTable.vue?vue&type=script&lang=ts"
export * from "./ValidationTable.vue?vue&type=script&lang=ts"

import "./ValidationTable.vue?vue&type=style&index=0&id=7108b9a4&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7108b9a4"]])

export default __exports__